/* eslint-disable no-new */
import BackToTopComponent from './back_to_top/back_to_top';

const footerInit = () => {
  new BackToTopComponent();
};

export default footerInit;
